import { Card } from "@mui/material"
import MDBox from "components/MDBox"
import BaseLayout from "layouts/pages/account/components/BaseLayout"
import { useDispatch, useSelector } from "react-redux"
import Loader from "components/Loader";
import MDTypography from "components/MDTypography"
import { useEffect } from "react";
import * as actions from "redux/actions/profile";
import * as actionType from "redux/constants"
import DoctorFilter from "./Doctor.filter";
import { Table } from "react-bootstrap";

const DoctorList = () => {
    const dispatch = useDispatch();
    const profile = useSelector((state) => state.profile);
    const auth = useSelector((state) => state.auth);


    useEffect(() => {
        if (auth?.user.role === actionType.SUPER_ADMIN) {
            dispatch(actions.getOrgDoctors());
        } else {
            dispatch(actions.getOrgDoctors(auth.user.email));
        }
    }, [dispatch]);

    // console.log()

    if (profile.loading) {
        return <Loader />;
    } else {
        return (
            <BaseLayout>
                {
                    auth.user.role === actionType.SUPER_ADMIN && <DoctorFilter />
                }
                <MDBox mt={4}>
                    <MDBox mb={3}>
                        <Card id="2fa" sx={{ overflow: "visible" }}>
                            <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
                                <MDTypography variant="h5">All Doctor list</MDTypography>
                                {/* <MDBadge variant="contained" color="success" badgeContent="enabled" container /> */}
                            </MDBox>
                            <MDBox p={3}>
                                <MDBox>
                                    <div>
                                        <Table striped bordered hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Customer id</th>
                                                    <th>Organization</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    profile.allProfiles?.doctors?.length > 0 &&
                                                    profile.allProfiles?.doctors?.map((ele, idx) => (
                                                        <tr key={idx}>
                                                            <td>{ele.firstName}</td>
                                                            <td>{ele.email}</td>
                                                            <td>{ele.customerId}</td>
                                                            <td>{ele.organisationName}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                        {
                                            !profile.allProfiles?.doctors?.length && <p className="text-center p-5">No data found ! </p>
                                        }
                                    </div>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </MDBox>
                </MDBox>
            </BaseLayout>
        )
    }


}

export default DoctorList